import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import CardManagementList from './components/CardManagementList';

const { Cell } = ResponsiveGrid;

const CardManagement = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="訪客卡片管理"
        // description="卡片列表"
        breadcrumbs={[
          {
            name: '訪客門禁',
          },
          {
            name: '訪客卡片管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <CardManagementList />
    </Cell>
  </ResponsiveGrid>
);

export default CardManagement;
